/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_DivisionsInputs */

const th_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกรุ่น`)
};

const en_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All divisions`)
};

const ja_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての部門`)
};

const zh_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部分区`)
};

const es_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las categorías`)
};

const pt_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as categorias`)
};

const id_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua divisi`)
};

const fr_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les catégories`)
};

const tl_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat ng dibisyon`)
};

const vi_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mọi bảng`)
};

const ko_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 디비전`)
};

const de_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Klassen`)
};

const ru_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все дивизионы`)
};

const tr_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm gruplar`)
};

const it_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le categorie`)
};

const pl_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie grupy`)
};

const uk_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі дивізіони`)
};

const hi_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी वर्ग`)
};

const ar_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل الفئات`)
};

const ms_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua divisyen`)
};

const bn_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব বিভাগ`)
};

const zh_tw2_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有分組`)
};

const zh_hk2_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有組別`)
};

const ur_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمام درجے`)
};

const fa_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`همهٔ گروه‌ها`)
};

const sw_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Madaraja yote`)
};

const nl_all_divisions = /** @type {(inputs: All_DivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle klassen`)
};

/**
* | output |
* | --- |
* | "All divisions" |
*
* @param {All_DivisionsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const all_divisions = /** @type {((inputs?: All_DivisionsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_DivisionsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_all_divisions(inputs)
	if (locale === "ja") return ja_all_divisions(inputs)
	if (locale === "zh") return zh_all_divisions(inputs)
	if (locale === "es") return es_all_divisions(inputs)
	if (locale === "pt") return pt_all_divisions(inputs)
	if (locale === "id") return id_all_divisions(inputs)
	if (locale === "fr") return fr_all_divisions(inputs)
	if (locale === "tl") return tl_all_divisions(inputs)
	if (locale === "vi") return vi_all_divisions(inputs)
	if (locale === "ko") return ko_all_divisions(inputs)
	if (locale === "de") return de_all_divisions(inputs)
	if (locale === "ru") return ru_all_divisions(inputs)
	if (locale === "tr") return tr_all_divisions(inputs)
	if (locale === "it") return it_all_divisions(inputs)
	if (locale === "pl") return pl_all_divisions(inputs)
	if (locale === "uk") return uk_all_divisions(inputs)
	if (locale === "hi") return hi_all_divisions(inputs)
	if (locale === "ar") return ar_all_divisions(inputs)
	if (locale === "ms") return ms_all_divisions(inputs)
	if (locale === "bn") return bn_all_divisions(inputs)
	if (locale === "zh-TW") return zh_tw2_all_divisions(inputs)
	if (locale === "zh-HK") return zh_hk2_all_divisions(inputs)
	if (locale === "ur") return ur_all_divisions(inputs)
	if (locale === "fa") return fa_all_divisions(inputs)
	if (locale === "sw") return sw_all_divisions(inputs)
	if (locale === "nl") return nl_all_divisions(inputs)
	return en_all_divisions(inputs)
});